import React, {useEffect, useState} from "react";
import {Button, Card, Col, Container, Form, Row} from "react-bootstrap";
import ErrorToast from "../common/ErrorToast"
import SuccessToast from "../common/SuccessToast"
import cloneDeep from "lodash/cloneDeep";
import {useDispatch, useSelector} from "react-redux";
import {getPractice, updatePracticeInformation} from "../../actions/admin/practiceInformationActions";

const componentName="PracticeInformation";

export const PracticeInformation = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const { payersDetails } = useSelector((state) => state.practiceInformation);
  const errors = useSelector((state) => state.errors);
  const success = useSelector(state => state.success);

  const updatePracticeInfo = () => {
  dispatch(updatePracticeInformation(formData))
  };

  useEffect(() => {
    dispatch(getPractice());
  }, [dispatch]);

  useEffect(() => {
    if (payersDetails) {
      const newObject = cloneDeep(payersDetails);
      setFormData(newObject);
    }
  }, [payersDetails]);

  const refresh = () => {
    const newObject = cloneDeep(payersDetails);
    setFormData(newObject);
  };

  const handleChange = (e, payerObj) => {
    const { name, value, checked } = e.target;
    if (
      name === "referralEmail1" ||
      name === "referralEmail2" ||
      name === "referralEmail3"
    ) {
      setFormData({
        ...formData,
        [name]: value,
      });
    } else {
      if (!formData?.payers?.length) return;
      const index = formData.payers.indexOf(payerObj);
      if (index < 0) return;
      const updatedPayers = formData.payers.map((payer, idx) =>
        idx === index ? { ...payer, selected: !!checked } : payer
      );
      setFormData({ ...formData, payers: updatedPayers });
    }
  };

  return (
    <Container fluid>
      <Row className="py-3">
        <Col>
          <Card>
            <Card.Body>
            <Row className="mb-3">
              <Col>
                <Card.Title id={`${componentName}-referralEmailsLabel`}>Referral Emails</Card.Title>
                <Card.Text id={`${componentName}-referralEmailsInstructions`}>
                  Referral Emails Please enter email addresses associated to your practice where referral notifications will be sent.
                </Card.Text>
                <Form.Group className="mb-3">
                  <Form.Label id={`${componentName}-emailLabel1`}>E-mail 1</Form.Label>
                  <Form.Control
                    type="email"
                    className="form-control"
                    name="referralEmail1"
                    id={`${componentName}-emailValue1`}
                    onChange={(e) => handleChange(e)}
                    value={formData?.referralEmail1 ?? ""}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label id={`${componentName}-emailLabel2`}>E-mail 2</Form.Label>
                  <Form.Control
                    type="email"
                    className="form-control"
                    name="referralEmail2"
                    id={`${componentName}-emailValue2`}
                    onChange={(e) => handleChange(e)}
                    value={formData?.referralEmail2 ?? ""}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label id={`${componentName}-emailLabel3`}>E-mail 3</Form.Label>
                  <Form.Control
                    type="email"
                    name="referralEmail3"
                    id={`${componentName}-emailValue3`}
                    onChange={(e) => handleChange(e)}
                    value={formData?.referralEmail3 ?? ""}
                  />
                </Form.Group>
              </Col>
            </Row>
            {errors?.message && <ErrorToast/>}
            {success?.message && <SuccessToast />}
            <Row>
              <Col className="d-flex justify-content-end">
                <Button id={`${componentName}-cancelButton`} variant="secondary" onClick={() => refresh()} className="me-2">
                  Cancel
                </Button>
                <Button id={`${componentName}-confirmButton`} variant="primary" onClick={() => updatePracticeInfo()}>
                  Confirm
                </Button>
              </Col>
            </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PracticeInformation;
